module.exports = "../dist/frontend/icons/symbols/cards/visa.svg?470464525e4c2db55d8307e4b12d9565";